import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from '../../../shared/i18n/translate/useTranslation';
import { IGatewayError } from '../../../shared/api/gateway/errors/IGatewayError';
import { SessionExpiredError } from './SessionExpiredError';
import { hasGatewayErrorCode } from '../../../shared/api/gateway/errors/hasGatewayErrorCode';
import { GatewayErrorResponseCode } from '../../../shared/api/gateway/errors/GatewayErrorResponseCode';
import { isGatewayError } from '../../../shared/api/gateway/errors/isGatewayError';
import { ErrorBar } from '../../../shared/components';
import { ITranslationKey } from '../../../shared/i18n/translate/models/ITranslationKey';

const errors: Record<GatewayErrorResponseCode, ITranslationKey> = {
	PARKING_PRODUCTS_QUOTE_EXPIRED: 'parking_booking_error_quote_expired',
	PAYMENT_ERROR: 'parking_booking_error_payment_error',
	BOOKING_NOT_FOUND: 'parking_booking_error_not_found',
	BOOKING_ALREADY_AMENDED: 'parking_booking_error_already_amended',
	PRODUCT_NOT_AVAILABLE: 'parking_booking_error_not_available',
	BOOKING_ALREADY_CANCELLED: 'parking_booking_error_already_cancelled',
	DUPLICATE_BOOKING: 'parking_booking_error_duplicate_booking',
	INVALID_PAYMENT_DETAILS: 'generic_error_message',
};

interface IApiErrorMessageProps {
	error: Error;
	sessionExpiredNextUrl?: string;
	genericMessage?: ITranslationKey;
	className?: string;
}

export const ApiErrorMessage = ({
	error,
	sessionExpiredNextUrl,
	genericMessage = 'generic_error_message',
	className,
}: IApiErrorMessageProps) => {
	const { t } = useTranslation();

	if (sessionExpiredNextUrl && isSessionExpiredError(error)) {
		return (
			<SessionExpiredError sessionExpiredNextUrl={sessionExpiredNextUrl} />
		);
	}

	let errorKey: ITranslationKey = genericMessage;
	if (isGatewayError(error) && error.response.data.code)
		errorKey = errors[error.response.data.code] ?? genericMessage;
	return <StyledErrorBar className={className}>{t(errorKey)}</StyledErrorBar>;
};

function isSessionExpiredError(error: Error | IGatewayError) {
	return hasGatewayErrorCode(
		error,
		GatewayErrorResponseCode.ParkingProductsQuoteExpired,
	);
}

const StyledErrorBar = styled(ErrorBar)`
	margin-top: 24px;
`;
